import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
export interface modelState {
  stateCartable:string;
  status:string;
}

const initialState: modelState = {
  stateCartable:'',
  status:'success'
}

export const Slice = createSlice({
  name: 'stateCartable',
  initialState,
  reducers: {
  
    stateCartableSet: (state, action) => {
    const {stateCartable,status} = action.payload;
    state.stateCartable = stateCartable;
    state.status = status;
    
  }
  },
})

// Action creators are generated for each case reducer function
export const { stateCartableSet } = Slice.actions

export default Slice.reducer